import React from 'react';
import styled from 'styled-components';

import { colors } from '@Components/design-system/color-v2';
import { BackgroundPalette, FillPalette, StrokePalette, TextPalette } from '@Components/design-system/color-v2/types';
import Icon from '@Components/design-system/icon';
import Text from '@Components/design-system/text-v2';
import { FontType } from '@Components/design-system/text-v2/types';

interface LanguageCardProps {
  language: string;
  isSelected: boolean;
  onClick: () => void;
}

const ConditionCard = ({ language, isSelected, onClick }: LanguageCardProps) => {
  return (
    <Container onClick={onClick} isSelected={isSelected}>
      <Text font={isSelected ? FontType.BODY_B : FontType.BODY_L} color={TextPalette.DARK_1} className='text-left'>
        {language}
      </Text>
      <Icon size='s' name={isSelected ? 'select_check_box' : 'check_box_outline_blank'}></Icon>
    </Container>
  );
};

export default ConditionCard;

const Container = styled.button<{ isSelected: boolean }>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  background-color: ${({ isSelected }) =>
    isSelected ? colors.fill[FillPalette.DARK_3] : colors.background[BackgroundPalette.LIGHT_1]};
  border: 1px solid
    ${({ isSelected }) => (isSelected ? colors.stroke[StrokePalette.DARK_1] : colors.stroke[StrokePalette.DARK_3])};
  border-radius: 16px;
  position: relative;
`;

const Tag = styled.div`
  position: absolute;
  top: -12px;
  right: -12px;
`;
